// Extra UI strings for the Dashboard, Generate Plan and History pages.
const pages = {
  pt: {
    yearsShort: 'anos',
    perWeek: 'x/semana',
    planLabel: 'Plano',
    seeAll: 'Ver todos',
    recentPlansDesc: 'Os teus últimos planos de treino gerados',
    noPlansYet: 'Ainda não tens planos de treino',
    historyTitle: 'Histórico de',
    plansWord: 'Planos',
    historyDesc: 'Consulta e gere todos os teus planos de treino',
    activePlans: 'Planos Ativos',
    completedPlansLabel: 'Planos Concluídos',
    filterLabel: 'Filtrar:',
    filterAll: 'Todos',
    filterActive: 'Ativos',
    filterCompleted: 'Concluídos',
    noPlansFound: 'Nenhum plano encontrado',
    createFirstPlanDesc: 'Cria o teu primeiro plano de treino personalizado',
    createFirstPlan: 'Criar Primeiro Plano',
    noCompletedPlans: 'Nenhum plano concluído',
    noActivePlans: 'Nenhum plano ativo',
    noneCompletedYet: 'Ainda não marcaste nenhum plano como concluído',
    allCompleted: 'Todos os planos estão concluídos',
    seeAllPlans: 'Ver todos os planos',
    completedLabel: 'Concluído',
    supersededLabel: 'Substituído',
    completedOn: 'Concluído em',
    planWeeks: 'Plano de {weeks} Semanas',
    focusLabel: 'Foco',
    weeksShort: 'sem.',
    generateWord: 'Gerar',
    planWord: 'Plano',
    chooseTypeDesc: 'Escolhe o tipo de treino e personaliza',
    unlimitedPlans: 'Planos ilimitados',
    monthlyLimitReached: 'Limite mensal atingido',
    errorLoading: 'Erro ao carregar dados',
    errorGenerating: 'Erro ao gerar plano',
    planGenerated: 'Plano gerado com sucesso!'
  },
  en: {
    yearsShort: 'years',
    perWeek: 'x/week',
    planLabel: 'Plan',
    seeAll: 'See all',
    recentPlansDesc: 'Your most recent generated workout plans',
    noPlansYet: "You don't have any workout plans yet",
    historyTitle: 'Plan',
    plansWord: 'History',
    historyDesc: 'Browse and manage all your workout plans',
    activePlans: 'Active Plans',
    completedPlansLabel: 'Completed Plans',
    filterLabel: 'Filter:',
    filterAll: 'All',
    filterActive: 'Active',
    filterCompleted: 'Completed',
    noPlansFound: 'No plans found',
    createFirstPlanDesc: 'Create your first personalised workout plan',
    createFirstPlan: 'Create First Plan',
    noCompletedPlans: 'No completed plans',
    noActivePlans: 'No active plans',
    noneCompletedYet: "You haven't marked any plan as completed yet",
    allCompleted: 'All plans are completed',
    seeAllPlans: 'See all plans',
    completedLabel: 'Completed',
    supersededLabel: 'Replaced',
    completedOn: 'Completed on',
    planWeeks: '{weeks} Week Plan',
    focusLabel: 'Focus',
    weeksShort: 'wk',
    generateWord: 'Generate',
    planWord: 'Plan',
    chooseTypeDesc: 'Choose the workout type and customise it',
    unlimitedPlans: 'Unlimited plans',
    monthlyLimitReached: 'Monthly limit reached',
    errorLoading: 'Error loading data',
    errorGenerating: 'Error generating plan',
    planGenerated: 'Plan generated successfully!'
  },
  es: {
    yearsShort: 'años',
    perWeek: 'x/semana',
    planLabel: 'Plan',
    seeAll: 'Ver todos',
    recentPlansDesc: 'Tus últimos planes de entrenamiento generados',
    noPlansYet: 'Todavía no tienes planes de entrenamiento',
    historyTitle: 'Historial de',
    plansWord: 'Planes',
    historyDesc: 'Consulta y gestiona todos tus planes de entrenamiento',
    activePlans: 'Planes Activos',
    completedPlansLabel: 'Planes Completados',
    filterLabel: 'Filtrar:',
    filterAll: 'Todos',
    filterActive: 'Activos',
    filterCompleted: 'Completados',
    noPlansFound: 'No se encontró ningún plan',
    createFirstPlanDesc: 'Crea tu primer plan de entrenamiento personalizado',
    createFirstPlan: 'Crear Primer Plan',
    noCompletedPlans: 'Ningún plan completado',
    noActivePlans: 'Ningún plan activo',
    noneCompletedYet: 'Todavía no has marcado ningún plan como completado',
    allCompleted: 'Todos los planes están completados',
    seeAllPlans: 'Ver todos los planes',
    completedLabel: 'Completado',
    supersededLabel: 'Sustituido',
    completedOn: 'Completado el',
    planWeeks: 'Plan de {weeks} Semanas',
    focusLabel: 'Enfoque',
    weeksShort: 'sem.',
    generateWord: 'Generar',
    planWord: 'Plan',
    chooseTypeDesc: 'Elige el tipo de entrenamiento y personalízalo',
    unlimitedPlans: 'Planes ilimitados',
    monthlyLimitReached: 'Límite mensual alcanzado',
    errorLoading: 'Error al cargar los datos',
    errorGenerating: 'Error al generar el plan',
    planGenerated: '¡Plan generado con éxito!'
  },
  fr: {
    yearsShort: 'ans',
    perWeek: 'x/semaine',
    planLabel: 'Formule',
    seeAll: 'Voir tout',
    recentPlansDesc: 'Tes derniers plans d’entraînement générés',
    noPlansYet: 'Tu n’as pas encore de plans d’entraînement',
    historyTitle: 'Historique des',
    plansWord: 'Plans',
    historyDesc: 'Consulte et gère tous tes plans d’entraînement',
    activePlans: 'Plans Actifs',
    completedPlansLabel: 'Plans Terminés',
    filterLabel: 'Filtrer :',
    filterAll: 'Tous',
    filterActive: 'Actifs',
    filterCompleted: 'Terminés',
    noPlansFound: 'Aucun plan trouvé',
    createFirstPlanDesc: 'Crée ton premier plan d’entraînement personnalisé',
    createFirstPlan: 'Créer le Premier Plan',
    noCompletedPlans: 'Aucun plan terminé',
    noActivePlans: 'Aucun plan actif',
    noneCompletedYet: 'Tu n’as encore marqué aucun plan comme terminé',
    allCompleted: 'Tous les plans sont terminés',
    seeAllPlans: 'Voir tous les plans',
    completedLabel: 'Terminé',
    supersededLabel: 'Remplacé',
    completedOn: 'Terminé le',
    planWeeks: 'Plan de {weeks} Semaines',
    focusLabel: 'Objectif',
    weeksShort: 'sem.',
    generateWord: 'Générer',
    planWord: 'Plan',
    chooseTypeDesc: 'Choisis le type d’entraînement et personnalise-le',
    unlimitedPlans: 'Plans illimités',
    monthlyLimitReached: 'Limite mensuelle atteinte',
    errorLoading: 'Erreur lors du chargement des données',
    errorGenerating: 'Erreur lors de la génération du plan',
    planGenerated: 'Plan généré avec succès !'
  },
  de: {
    yearsShort: 'Jahre',
    perWeek: 'x/Woche',
    planLabel: 'Abo',
    seeAll: 'Alle ansehen',
    recentPlansDesc: 'Deine zuletzt erstellten Trainingspläne',
    noPlansYet: 'Du hast noch keine Trainingspläne',
    historyTitle: 'Verlauf der',
    plansWord: 'Pläne',
    historyDesc: 'Sieh dir alle deine Trainingspläne an und verwalte sie',
    activePlans: 'Aktive Pläne',
    completedPlansLabel: 'Abgeschlossene Pläne',
    filterLabel: 'Filter:',
    filterAll: 'Alle',
    filterActive: 'Aktiv',
    filterCompleted: 'Abgeschlossen',
    noPlansFound: 'Keine Pläne gefunden',
    createFirstPlanDesc: 'Erstelle deinen ersten personalisierten Trainingsplan',
    createFirstPlan: 'Ersten Plan Erstellen',
    noCompletedPlans: 'Keine abgeschlossenen Pläne',
    noActivePlans: 'Keine aktiven Pläne',
    noneCompletedYet: 'Du hast noch keinen Plan als abgeschlossen markiert',
    allCompleted: 'Alle Pläne sind abgeschlossen',
    seeAllPlans: 'Alle Pläne ansehen',
    completedLabel: 'Abgeschlossen',
    supersededLabel: 'Ersetzt',
    completedOn: 'Abgeschlossen am',
    planWeeks: '{weeks}-Wochen-Plan',
    focusLabel: 'Fokus',
    weeksShort: 'Wo.',
    generateWord: 'Plan',
    planWord: 'erstellen',
    chooseTypeDesc: 'Wähle die Trainingsart und passe sie an',
    unlimitedPlans: 'Unbegrenzte Pläne',
    monthlyLimitReached: 'Monatslimit erreicht',
    errorLoading: 'Fehler beim Laden der Daten',
    errorGenerating: 'Fehler beim Erstellen des Plans',
    planGenerated: 'Plan erfolgreich erstellt!'
  },
  it: {
    yearsShort: 'anni',
    perWeek: 'x/settimana',
    planLabel: 'Piano',
    seeAll: 'Vedi tutti',
    recentPlansDesc: 'I tuoi ultimi piani di allenamento generati',
    noPlansYet: 'Non hai ancora piani di allenamento',
    historyTitle: 'Cronologia dei',
    plansWord: 'Piani',
    historyDesc: 'Consulta e gestisci tutti i tuoi piani di allenamento',
    activePlans: 'Piani Attivi',
    completedPlansLabel: 'Piani Completati',
    filterLabel: 'Filtra:',
    filterAll: 'Tutti',
    filterActive: 'Attivi',
    filterCompleted: 'Completati',
    noPlansFound: 'Nessun piano trovato',
    createFirstPlanDesc: 'Crea il tuo primo piano di allenamento personalizzato',
    createFirstPlan: 'Crea il Primo Piano',
    noCompletedPlans: 'Nessun piano completato',
    noActivePlans: 'Nessun piano attivo',
    noneCompletedYet: 'Non hai ancora segnato nessun piano come completato',
    allCompleted: 'Tutti i piani sono completati',
    seeAllPlans: 'Vedi tutti i piani',
    completedLabel: 'Completato',
    supersededLabel: 'Sostituito',
    completedOn: 'Completato il',
    planWeeks: 'Piano di {weeks} Settimane',
    focusLabel: 'Focus',
    weeksShort: 'sett.',
    generateWord: 'Genera',
    planWord: 'Piano',
    chooseTypeDesc: 'Scegli il tipo di allenamento e personalizzalo',
    unlimitedPlans: 'Piani illimitati',
    monthlyLimitReached: 'Limite mensile raggiunto',
    errorLoading: 'Errore nel caricamento dei dati',
    errorGenerating: 'Errore nella generazione del piano',
    planGenerated: 'Piano generato con successo!'
  }
};

export default pages;
